import { render } from "./GiftAdd.vue?vue&type=template&id=bbfe4742"
import script from "./GiftAdd.vue?vue&type=script&lang=js"
export * from "./GiftAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__